import $ from 'jquery';
import Timer from '../../components/timer';
import VideoModalButton from '../../components/video-modal-button';
import MainSlider from './components/main-slider';
import RevealWhenVisible from '../../components/reveal-when-visible';
import SubNavSlider from './components/sub-nav-slider';
$(() => {
    MainSlider.init();
    Timer.init();
    RevealWhenVisible.init();
    VideoModalButton.init();
    SubNavSlider.init();
});
